// src/app/providers/i18n.ts
import { createI18n } from 'vue-i18n'
import { availableLocales, defaultLocale, messages } from '@/shared/config/i18n'

const LOCALE_STORAGE_KEY = 'app_locale'

function getInitialLocale(): string {
  const savedLocale = localStorage.getItem(LOCALE_STORAGE_KEY)
  if (savedLocale && availableLocales.includes(savedLocale)) {
    return savedLocale
  }
  return defaultLocale
}

// Russian pluralization: 1=месяц, 2-4=месяца, 5-20=месяцев
function russianPlural(choice: number, choicesLength: number): number {
  if (choicesLength < 3) 
    return choice === 1 ? 0 : 1

  const mod10 = choice % 10
  const mod100 = choice % 100

  if (mod10 === 1 && mod100 !== 11) 
    return 0 // месяц
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) 
    return 1 // месяца
  return 2 // месяцев
}

const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages,
  pluralRules: {
    ru: russianPlural,
  },
  globalInjection: true,
})

export { i18n }
